import React from 'react';
import Svg, { ISvgProps } from './_module/Svg';

interface IProps extends Omit<ISvgProps, 'svgIcon'> {}

export default function KeepitalMinisiteAppSvg(props: IProps) {
  const { width, height } = props;
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      svgIcon='<path class="frame brand-gray" d="M3,3v26h26V3H3z M28,28H4V8h24V28z M28,7H4V4h24V7z"/><rect class="close brand-danger" x="26" y="5" width="1" height="1"/><rect class="maximize brand-success" x="24" y="5" width="1" height="1"/><rect class="minimize brand-warning" x="22" y="5" width="1" height="1"/><polygon class="building brand-info" points="16.3,20.9 10.9,24.4 10.9,26.1 16.3,26.1"/><polygon class="building brand-primary" points="13.8,21.9 14.9,21.2 14.9,12.2 17.3,13.8 17.3,9.2 12,12.8 12,16.4 13.8,15.2"/><polygon class="building brand-danger" points="10.4,24.1 13.3,22.2 13.3,16.1 7.9,19.7 7.9,26.1 10.4,26.1"/><polygon class="building brand-warning" points="18.4,18.2 23.8,21.7 23.8,26.1 18.4,26.1"/><polygon class="building brand-success" points="17.9,26.1 17.9,17.2 20.7,19.1 20.7,16.7 15.4,13.1 15.4,20.8 16.8,19.9 16.8,26.1 16.8,26.1 17.9,26.1"/>'
    />
  );
}
